import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {getAssetPathForRouteTypeIcon} from '../../../utils/icon.util';
import {UnrRouteListItem} from './model/route-list-item.model';

@Component({
  selector: 'unr-roadtrip-list-item',
  templateUrl: 'roadtrip-list-item.component.html',
  styleUrls: ['roadtrip-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnrRoadtripListItemComponent {

  @Input() data: UnrRouteListItem;

  getIconLabel(): string {
    return getAssetPathForRouteTypeIcon(this.data.iconName);
  }
}
